import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const ButtonLibrasMenuContainer = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  width: 50px;
  height: 50px;
  justify-content: center;
  padding: 0 3%;
  box-shadow: rgba(0, 0, 0, 0.15) 0rem 0rem 0.125rem 0.094rem;
  font-size: 0.75em;
  gap: 0.938rem;
  background-color: var(--blue);
  color: white;
  border: none;
  transition: filter 0.2s, background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: var(--dark-blue);
    filter: brightness(0.9);
  }

  &:active {
    transform: scale(0.95);
  }

  &.running {
    filter: brightness(0.6);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
    filter: brightness(0.8);
  }

  .btnSpinner {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    flex-shrink: 0;
    box-sizing: border-box;

    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top: 2px solid #fff;
    border-radius: 50%;

    animation: ${spin} 0.8s linear infinite;
  }

  &:disabled::after {
    display: none;
  }

  @media (max-width: 42.813rem) {
    font-size: 0.75em;
    gap: 0.313rem;

    img {
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  @media (max-width: 768px){
      font-size: 0.75em;
      gap: 0.313rem;  
      img {
        width: 2.2rem;
        height: 2.2rem;
      }
    }
`;
